export const ExternalLinkIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="var(--swapper-primary-color)"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path d="M4.22222 22.5C3.61111 22.5 3.08796 22.2824 2.65278 21.8472C2.21759 21.412 2 20.8889 2 20.2778V4.72222C2 4.11111 2.21759 3.58796 2.65278 3.15278C3.08796 2.71759 3.61111 2.5 4.22222 2.5H12V4.72222H4.22222V20.2778H19.7778V12.5H22V20.2778C22 20.8889 21.7824 21.412 21.3472 21.8472C20.912 22.2824 20.3889 22.5 19.7778 22.5H4.22222ZM9.44445 16.6111L7.88889 15.0556L18.2222 4.72222H14.2222V2.5H22V10.2778H19.7778V6.27778L9.44445 16.6111Z" />
    </svg>
  );
};
